<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?node-id=2%3A2&mode=dev -->
<template>
  <div class="character-list">
    <div
      class="quote-wrapper"
      :class="wrapperClass"
    >
      <div class="quote__author-wrapper">
        <img
          v-if="character.image_url"
          :src="character.image_url"
          class="quote__author-image"
        />
        <div class="quote__author-about">
          <div
            ref="title"
            class="quote__author-title"
          >
            <TheContent
              v-for="item of character.title"
              :key="item.id"
              :elem="item"
            />
          </div>

          <div
            v-if="character.details"
            ref="details"
            class="quote__author-description"
          >
            <TheContent
              v-for="item of character.details"
              :key="item.id"
              :elem="item"
            />
          </div>
        </div>
      </div>
      <blockquote
        v-if="character.text"
        class="quote__content"
      >
        <TheContent
          v-for="item of character.text"
          :key="item.id"
          :elem="item"
        />
      </blockquote>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { CharactersListAttributes } from '~/types/components/CharacterList';
  import TheContent from '~/components/content/TheContent';
  import { CHARACTER_LIST_WRAPPED_TYPES } from '~/constants/gutenberg';

  export default defineNuxtComponent({
    name: 'CharactersList',

    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent<CharactersListAttributes>>,
        required: true,
      },
    },

    computed: {
      character(): CharactersListAttributes {
        return this.elem.attributes;
      },

      wrapperClass(): Record<string, boolean> {
        return {
          'quote-wrapper--wrapped': !!CHARACTER_LIST_WRAPPED_TYPES.includes(this.elem.type),
        };
      },

      titleForAnalytics(): string {
        return this.character?.title?.reduce(
          (result, elem) => result + (elem.type === 'a' ? elem.children[0].text : elem.text),
          '',
        );
      },
    },
  });
</script>

<style lang="scss" scoped>
  $avatar-sizes: 88px;

  .quote {
    &__content > *:not(:last-child) {
      margin-bottom: 16px;
    }

    &-wrapper {
      margin: 24px 0;
      border: 0px solid #ebebeb;
      position: relative;

      :deep() {
        > *:last-child,
        > *:last-child > *:last-child {
          margin-bottom: 0;
        }
      }

      &--wrapped {
        @include quoteIcon;
        border-width: 1px 0;

        padding: 24px 8px 32px;

        @include tablet {
          padding: 24px 16px 32px;
        }
      }
    }

    &__author {
      color: #000000;

      &-wrapper {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;

        @include tablet {
          flex-wrap: nowrap;
          gap: 16px;
        }
      }

      &-about {
        align-self: center;
        width: 100%;
      }

      &-image {
        border: 1px solid $borderColor;
        width: $avatar-sizes;
        height: $avatar-sizes;
        border-radius: 50%;
        object-fit: cover;

        @include tablet {
          margin-left: 4px;
        }
      }

      &-title {
        @include normalText;

        font-weight: 600;
        font-family: $secondFont;
        margin-bottom: 4px;
        text-align: center;

        @include tablet {
          @include mediumText;
          text-align: left;
          margin-top: 8px;
        }
      }

      &-description {
        @include smallText;

        @include tablet {
          @include normalText;

          text-align: unset;
        }
      }
    }
  }
</style>
